module.exports = __webpack_public_path__ + "static/media/how-progression.92021584.png";